/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import NProgress from 'nprogress';
import Backbone from 'backbone';
import _ from 'lodash';

import Scaffold from '@/Scaffold';
import * as NavUtils from '@/util/NavUtils';
import { userHasRole } from '@/util/RoleUtils';

import AWPackageDashboardPage from '../pages/AWPackageDashboardPage';
import ErrorView from '../../common/views/ErrorView/ErrorView';

export default async function ShowAWPackageDashboardPage() {
  NProgress.start();
  try {
    if (userHasRole('EPC')) {
      NavUtils.navigate('aw-packages');
    } else {
      showErrorView();
      return;
    }

    Scaffold.getRegion('content').show(
      new AWPackageDashboardPage({
        model: new Backbone.Model({})
      })
    );
  } catch (e) {
    Scaffold.getRegion('content').show(
      new ErrorView({
        model: new Backbone.Model({
          errorMessage: 'An Error Occurred',
          errorDetails: 'Something went wrong while loading the AW Packages Dashboard.'
        })
      })
    );
  } finally {
    NProgress.done();
  }
}

function showErrorView(err) {
  Scaffold.getRegion('content').show(
    new ErrorView({
      model: new Backbone.Model({
        errorMessage: _.isString(err?.message) ? err?.message : 'Access Denied',
        errorDetails: 'Your account may not have permission to view the AW Packages Dashboard.'
      })
    })
  );
}
